"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiServiceModule = void 0;
const helpers_1 = require("../../core/helpers");
const LOG_PREFIX = '[Api Service]:';
__exportStar(require("./types"), exports);
class ApiServiceModule {
    constructor({ xhr, urlBuilder }) {
        this.xhr = xhr;
        this.urlBuilder = urlBuilder;
    }
    exec(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.do(params);
                helpers_1.Log.info(LOG_PREFIX + '  getting service');
                const validation = this.validate(result);
                if (validation.ok) {
                    return Promise.resolve(this.parse(result));
                }
                return Promise.reject(new Error(validation.error));
            }
            catch (e) {
                helpers_1.Log.warn(LOG_PREFIX + ' - error getting service');
                return Promise.reject(e);
            }
        });
    }
}
exports.ApiServiceModule = ApiServiceModule;
//# sourceMappingURL=index.js.map